// src/components/QROverlaySimple.tsx
import React from "react";

type Props = {
  /** 가이드 박스 가로폭 비율(%) – 컨테이너 기준 */
  boxWidthPct?: number;        // 기본 64
  /** 가로:세로 비율 – QR은 1, 바코드는 >1 */
  aspectRatio?: number;        // 기본 1
  /** 테두리 색/두께/라운드 */
  borderColor?: string;        // 기본 "#00FFA3"
  borderWidth?: number;        // px, 기본 3
  borderRadius?: number;       // px, 기본 12
};

const QROverlay: React.FC<Props> = ({
  boxWidthPct = 64,
  aspectRatio = 1,
  borderColor = "#00ff00",
  borderWidth = 3,
  borderRadius = 3,
}) => {
  const w = Math.max(30, Math.min(95, boxWidthPct)); // 안전 범위
  const h = w / aspectRatio;

  const leftPct = (100 - w) / 2;
  const topPct = (100 - h) / 2;

  // 마스크로 가운데 사각형만 “뚫고”, 그 외 영역은 어둡고 흐리게(blur) 처리
  const maskCss = `
    linear-gradient(#000 0 0) center / ${w}% ${h}% no-repeat,
    linear-gradient(#000 0 0)
  `;

  return (
    <div
      aria-hidden
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
      }}
    >
      {/* 흐림+야간(어둡게) 레이어: 가운데 사각형은 마스크로 투명 처리 */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          // 흐림 & 어둡게 (지원 브라우저)
          backdropFilter: "blur(3px) brightness(60%)",
          WebkitBackdropFilter: "blur(3px) brightness(60%)",
          // 폴백: 흐림 미지원 시 어둡게만
          background: "rgba(0,0,0,0.35)",
          // 가운데 사각형 구멍 마스크
          mask: maskCss as any,
          WebkitMask: maskCss as any,
          // 마스크 합성: 첫 번째 레이어를 '구멍'으로
          // (브라우저별 처리 차이 있어 둘 다 지정)
          maskComposite: "exclude" as any,
          WebkitMaskComposite: "xor" as any,
        }}
      />

      {/* 중앙 사각형 가이드(테두리만) */}
      <div
        style={{
          position: "absolute",
          left: `${leftPct}%`,
          top: `${topPct}%`,
          width: `${w}%`,
          height: `${h}%`,
          border: `${borderWidth}px solid ${borderColor}`,
          borderRadius: borderRadius,
          boxSizing: "border-box",
        }}
      />
    </div>
  );
};

export default QROverlay;
// src